export default "__VITE_ASSET__CdG6DSRn__"